var slider = new Swiper('.game-slider', {
    autoplay: true,
    loop: true,
    spaceBetween: 10,
    slidesPerView: 1.5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })